import { Exit } from 'effect';
import { Auth } from 'aws-amplify';
import { redirectToApp, getAppRedirectData, getBackUrl } from './services';

const amplifyAuthHandler = async ({ payload: { event, data } }, setAuthorizedUserContext) => {
  switch (event) {
    case 'signIn':
        const backUrl = getBackUrl();
        const resultExit = await getAppRedirectData(backUrl);

        Exit.match(resultExit, {
          onFailure: (cause) => {
            console.error('PostLogin API failure:', cause);

            const error = cause?.error;
            const isIpRestriction = error?._tag === 'ValidatedResponseError' &&
              error.status === 403 && error.validatedBody?.type === 'invalid_remote_address';
            const isValidatedResponseError = error?._tag === 'ValidatedResponseError';

            // Set appropriate context based on error type
            setAuthorizedUserContext(
              isIpRestriction ? { isIpRestricted: true } : { redirectError: true }
            );

            // Sign out for: IP restriction OR non-4xx errors
            // Other 4xx errors already signed out in services.ts
            if (isIpRestriction) {
              // Store in sessionStorage to survive the signOut redirect
              sessionStorage.setItem('ipRestricted', 'true');
              Auth.signOut();
            } else if (!isValidatedResponseError) {
              Auth.signOut();
            }
          },
          onSuccess: (data) => {
            // Clear IP restriction flag on successful login
            sessionStorage.removeItem('ipRestricted');

            const { phoneVerificationRequired, redirectUrl } = data
            if (!phoneVerificationRequired) {
              redirectToApp(redirectUrl);
              return;
            }
            // sets phoneVerificationRequired flag that controls extra steps in App.js
            setAuthorizedUserContext({ appUrl: redirectUrl,  phoneVerificationRequired });
          },
        });
      break;
    case 'signIn_failure':
    case 'cognitoHostedUI_failure':
    case 'customState_failure':
      // this indicates SSO error, for other auth type errors we should have code field present
      if (!data.code) {
        setAuthorizedUserContext({ ssoFailureMessage: data.message });
      }
      break;
    default:
      break;
  }
};

export default amplifyAuthHandler;
